<template>
	<app-page>
		<app-heading :title="isNew ? 'New Fixed Page' : page.name" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;" class="mt-4">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: 'website-template-pages' }">Cancel</app-button>
				</app-section-actions>
				<input-text
					label="Name"
					v-model="page.name"
					required
					:errors="errors.name"
				/>
				<input-text
					label="Slug"
					v-model="page.slug"
					required
					:errors="errors.slug"
				/>
				<input-text
					label="Url"
					v-model="page.url"
					required
					:errors="errors.url"
					hint="URL without the first / and without the parent URL"
				/>
				<input-text
					label="Version"
					type="number"
					v-model="page.version"
					required
					:errors="errors.version"
				/>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			page: {
				name: '',
				slug: '',
				url: '',
				version: 1,
			},
			errors: {},
		}
	},
	computed: {
		id() {
			return this.$route.params.page
		},
		templateId() {
			return this.$route.params.template
		},
		isNew() {
			return this.id === 'new'
		},
	},
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			if (this.id !== 'new') {
				this.page = await this.$ravello.request()
					.v(2)
					.to('websitetemplates')
					.to(this.templateId)
					.to('pages')
					.to(this.id)
					.get()
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}
		this.$store.dispatch('app/stopLoading')
	},
	methods: {
		async onSubmit() {
			this.$store.dispatch('app/startLoading')

			const payload = {
				name: this.page.name,
				slug: this.page.slug,
				url: this.page.url,
				version: this.page.version,
			}

			try {
				if (this.isNew) {
					await this.$ravello.request()
						.v(2)
						.to('websitetemplates')
						.to(this.templateId)
						.to('pages')
						.create(payload)
				} else {
					await this.$ravello.request()
						.v(2)
						.to('websitetemplates')
						.to(this.templateId)
						.to('pages')
						.to(this.id)
						.update(payload)
				}
				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', `Page successfully ${this.isNew ? 'added' : 'updated'}`)
				this.$router.push({ name: 'website-template-pages' })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
